
export {
    getAgentFeeFromLanded,
    getOfferCost,
    getAgentFee,
    getYenFromLanded,
    getLandedCost,
    bidColourStyle,
    filterBidUser
};

function getAgentFeeFromLanded(yen, fees) {
    let fee = 0;
    yen = Math.round(yen/1000)*1000;
    let extra = 0;
    if (fees.agent_fees && fees.agent_fees.length) {
        fees.agent_fees.forEach(agent_fee => {
            if (fee === 0) { //only check until we find a fee
                const use_fee = (yen <= (agent_fee.price_max + agent_fee.fee) || !agent_fee.price_max)
                if (use_fee) {
                    fee = agent_fee.fee;
                }
            }
        });
    } else {
        throw 'error: no fees found'
    }
    if (fees.agent_fee_step > 0
        && fees.agent_fee_step_after > 0
        && fees.agent_fee_step_value > 0
        && (yen - fee) > fees.agent_fee_step_after) {
        let price = fees.agent_fee_step_after;
        let top = price + fee;
        while (!(yen < top)) {
            price += fees.agent_fee_step;
            fee += fees.agent_fee_step_value;
            top = price + fee;
        }
    }
    if (fee === 0) {
        throw 'error: agent fee is 0, there\'s a problem'
    }
    return extra + fee;
}
function getAgentFee(bidYen, fees)
{
    let fee = 0;
    let extra = 0;
    if (fees.agent_fees && fees.agent_fees.length) {
        fees.agent_fees.forEach(agent_fee => {
            if (bidYen >= agent_fee.price_min && (bidYen < agent_fee.price_max || !agent_fee.price_max)) {
                fee = agent_fee.fee;
            }
        });
    } else {
        throw 'error: no fees found'
    }
    if (parseInt(fees.agent_fee_step) > 0
        && parseInt(fees.agent_fee_step_after) > 0
        && parseInt(fees.agent_fee_step_value) > 0
        && bidYen > parseInt(fees.agent_fee_step_after)) {
        let multiplier = parseInt(Math.floor((bidYen - fees.agent_fee_step_after) / fees.agent_fee_step));
        let value = parseInt(fees.agent_fee_step_value);
        extra = parseInt(multiplier * value) + 20000;
    }
    if (fee === 0) {
        throw 'error: agent fee is 0, there\'s a problem'
    }
    return extra + fee;
}
function getYenFromLanded(landedCost, pricingRule, currency_code)
{
    let ex_rate = currencyRate[currency_code.toLowerCase()] + jpyOffset;
    let fees = pricingRule.shipping + pricingRule.shipping_gst + pricingRule.bunker + pricingRule.brokerage + pricingRule.other + pricingRule.stink_bug;
    let yen = ((landedCost - fees) / (1 + 15 / 100)) * ex_rate;
    if (yen > 0) {
        try{
            let agent_fee = getAgentFeeFromLanded(yen, pricingRule);

            yen = yen - agent_fee;
            let calc = Math.round(yen / 1000);
            return calc * 1000;
        } catch (e){
            console.warn(e);
        }
    } else {
        return 0;
    }
}
function bidColourStyle(bid){
    if (bid && bid.user && bid.user.profile && bid.user.profile.bid_color) {
        return 'background-color: ' + bid.user.profile.bid_color;
    }
    return '';
}
function filterBidUser(user_id){
    this.filteredUsers = user_id
    this.getData()
}
function getLandedCost(bidPrice, pricingRule, currency_code) {
    //calculate landed cost...
    let ex_rate = currencyRate[currency_code.toLowerCase()] + jpyOffset;
    let fees = pricingRule.shipping + pricingRule.shipping_gst + pricingRule.bunker + pricingRule.brokerage + pricingRule.other + pricingRule.stink_bug;
    let agent_fee = getAgentFee(bidPrice, pricingRule);
    let cost = (((bidPrice + agent_fee) / ex_rate) * (1.15)) + fees;
    return parseInt(cost);
}

function getOfferCost(bidPrice, pricingRule, ex_rate) {
    //calculate stock offer price...
    let fees = pricingRule.shipping + pricingRule.bunker + pricingRule.other + pricingRule.stink_bug;
    let agent_fee = getAgentFee(bidPrice, pricingRule);
    const total_fob = bidPrice + agent_fee
    const sub_total = total_fob / ex_rate;
    const sub_total2 = sub_total + fees;
    const gst = (sub_total * 1.15) + pricingRule.shipping_gst
    let cost = sub_total2 + (gst - sub_total) + pricingRule.brokerage;
    return parseInt(cost);
}



// WEBPACK FOOTER //
// ./resources/js/util/bid_helper.js